import { apiSlice } from './apiSlice';
import { SHIFTREQUEST_URL } from '../constants';

export const shiftRequestApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create a new shift
    createShiftRequest: builder.mutation({
      query: (shiftRequestData) => ({
        url: `${SHIFTREQUEST_URL}`,
        method: 'POST',
        body: shiftRequestData,
      }),
    }),

    getShiftRequestsByShiftId: builder.query({
      query: (shiftId) => `${SHIFTREQUEST_URL}/shift-requests/${shiftId}`,
}),



    // Get all shifts
    getShiftRequests: builder.query({
      query: () => ({
        url: `${SHIFTREQUEST_URL}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Add this inside endpoints: (builder) => ({ ... })
getShiftRequestsByUserId: builder.query({
  query: (userId) => ({
    url: `${SHIFTREQUEST_URL}/user/${userId}`,
  }),
  keepUnusedDataFor: 5,
}),

updateShiftRequestStatus: builder.mutation({
  query: ({ shiftRequestId, lineStatus }) => ({
    url: `${SHIFTREQUEST_URL}/linestatus/${shiftRequestId}`,
    method: 'PATCH',
    body: { lineStatus },
  }),
}),

updateShiftRequestStatusAll: builder.mutation({
  query: ( update ) => ({
    url: `${SHIFTREQUEST_URL}/linestatus/${update._id}`,
    method: 'PATCH',
    body: update,
  }),
}),



    // Get a single shift by ID
    getShiftRequestById: builder.query({
      query: (shiftRequestId) => ({
        url: `${SHIFTREQUEST_URL}/${shiftRequestId}`,
      }),
      keepUnusedDataFor: 5,
    }),

    // Update a shift
    updateShiftRequest: builder.mutation({
  query: (data) => ({
        url: `${SHIFTREQUEST_URL}/${data.shiftRequestId}`,
        method: 'PUT',
        body: data,
  }),
}),



    // Delete a shift (logical or physical based on your controller logic)
    deleteShiftRequest: builder.mutation({
      query: (requestId) => ({
        url: `${SHIFTREQUEST_URL}/${requestId}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useCreateShiftRequestMutation,
  useGetShiftRequestsQuery,
  useGetShiftRequestByIdQuery,
  useGetShiftRequestsByUserIdQuery,
  useUpdateShiftRequestMutation,
  useDeleteShiftRequestMutation,
  useGetShiftRequestsByShiftIdQuery,
  useUpdateShiftRequestStatusMutation,
  useUpdateShiftRequestStatusAllMutation,
} = shiftRequestApiSlice;



